<template>
<div class="filter" :class="{ 'l_expanded' : isExpanded, 's_active' : isOpen, 's_on' : optionId }" data-type="select" :data-id=code>
  <div class="filter-sublabel" :class="{ 's_active' : optionId }">
    {{ label }}
  </div>
  <button class="filter-label" @click="toggleFilter">
    <span>{{ displayLabel }}</span>
    <svg class="icon filter-icon"><use xlink:href="#chevron-down"></use></svg>
  </button>
  <div class="filter-options">
    <ul class="filter-ul">
      <li class="filter-li" v-if="hasAll"><a href="/news/" tabindex="-1" data-id="" :data-val=allLabel class="filter-option" :class="{ 's_active' : !optionId }" @click="clickOption">{{ allLabel }} <span></span></a></li>
      <li class="filter-li" v-for="option in options" v-bind:key="option.id">
        <a class="filter-option" :class="{ 's_active' : option.id == optionId }" :href=option.url :tabindex=tabIndex :data-id=option.id :data-val=option.title @click="clickOption">{{ option.title }} <span></span></a>
      </li>
    </ul>
  </div>
</div>
</template>

<script>
import EventBus from '../utils/event-bus';

export default {
  name: "FilterSelect",
  data() {
    return {
      isOpen: false,
      optionId: false,
      optionVal: false,
      displayLabel: ''
    };
  },
  props: {
    code: String,
    label: String,
    allLabel: String,
    hasAll: {
      type: Boolean,
      default: true
    },
    options: Array,
    selected: String,
    isExpanded: {
      type: Boolean,
      required: false,
      default: false
    },
    isDynamic: {
      type: Boolean,
      default: true
    },
  },
  computed: {
    tabIndex: function() {
      if (this.isOpen) {
        return '';
      } else {
        return '-1';
      }
    }
  },
  methods: {

    toggleFilter(event) {
      this.isOpen = !this.isOpen;
      event.preventDefault();
    },

    openFilter() {
      this.isOpen = true;
    },

    closeFilter() {
      this.isOpen = false;
    },

    setOption(id, val, url) {
      if (typeof id !== 'undefined' && typeof val !== 'undefined') {
        this.optionId = id;
        this.optionVal = val;
        this.displayLabel = this.optionVal;

        // console.log(url);
        // history.pushState(
        //   {},
        //   null,
        //   url
        // );
      }
      this.onChange();
    },

    clickOption(event) {
      if (this.isDynamic) {
        var dataId = event.currentTarget.getAttribute('data-id');
        var dataVal = event.currentTarget.getAttribute('data-val');
        var dataUrl = event.currentTarget.getAttribute('href');
        this.setOption(dataId, dataVal, dataUrl);
        this.closeFilter();
        event.preventDefault();
      }
    },

    onChange() {
      EventBus.$emit('FILTER_VAR', this.code, this.optionId);
    }

  },
  mounted() {

    this.displayLabel = this.allLabel;

    window.addEventListener('load', () => {
      if (this.selected) {
        var selectedOption = this.options.filter((opt) => {
          return opt.slug == this.selected;
        });
        // console.log(selectedOption);
        if (selectedOption.length) {
          this.setOption(selectedOption[0].id, selectedOption[0].title);
        }
      }
    })

  }
};
</script>

<style scoped>
</style>